import { DivWithTooltip } from "Components/withPopover";
import gridBase64 from "Content/images/graph/gridBase64";
import React, { useCallback } from "react";
import locale from "./groupNodeTableIcon.locale";
export default function GroupNodeTableIcon(props) {
    const handleClick = useCallback((e) => {
        if (props.onClick) {
            e.stopPropagation();
            props.onClick();
        }
    }, [props.onClick]);
    const tableIconStyles = {
        width: props.width,
        height: props.height,
        zIndex: 2,
        cursor: "pointer",
        display: "grid",
        justifyContent: "center",
        alignItems: "center",
        ...props.positionStyles
    };
    return (React.createElement(DivWithTooltip, { style: tableIconStyles, onClick: handleClick, popoverContent: locale.TABLE_VIEW, zIndex: props.zIndex, className: props.className, onMouseEnter: props.onMouseEnter, onMouseLeave: props.onMouseLeave }, props.isExporting ? (React.createElement("img", { src: gridBase64 })) : (React.createElement("i", { className: "icon-grid font-h4 text-primary-500 line-height-1" }))));
}
GroupNodeTableIcon.defaultProps = {
    positionStyles: {},
    width: 20,
    height: 20
};
